import { render, staticRenderFns } from "./mallGoods.vue?vue&type=template&id=67cfd9e8&scoped=true&"
import script from "./mallGoods.vue?vue&type=script&lang=js&"
export * from "./mallGoods.vue?vue&type=script&lang=js&"
import style0 from "./mallGoods.vue?vue&type=style&index=0&id=67cfd9e8&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cfd9e8",
  null
  
)

export default component.exports